import { createActions } from 'redux-actions';

import { HealthPlan } from '@models/HealthPlan';

export type State = {
  healthPlans: HealthPlan[];
};

export type StateUpdatePayload = Partial<State>;

export const {
  healthPlansFetch,
  stateUpdate,
} = createActions(
  'HEALTH_PLANS_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'FEATURE_HEALTH_PLAN',
  },
);
